import { createStyles } from "@mantine/emotion";

export const useStylesNotification = createStyles((theme) => ({
  notificationBlock: {
    backgroundColor: theme.customBackgrounds.notification,
    color: theme.customColors.black,
    border: theme.customColors.borderNotification,
    textAlign: "center",
    padding: theme.spacing.notification.block.padding,
    position: "absolute",
    top: theme.spacing.notification.block.top,
    width: theme.spacing.notification.block.width,
    left: theme.spacing.notification.block.left,
    borderRadius: theme.spacing.notification.block.borderRadius,
    boxShadow: theme.spacing.notification.block.boxShadow,
    zIndex: "1",
  },

  notificationBlockText: {
    fontSize: theme.spacing.notification.text.fontSize.default,
    paddingTop: theme.spacing.notification.text.paddingTop.default,
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      fontSize: theme.spacing.notification.text.fontSize.desktop,
      paddingTop: theme.spacing.notification.text.paddingTop.desktop,
    },
    b: {
      fontWeight: "bolder",
    },
  },

  notificationBlockButtons: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "0.67em",
    maxWidth: "16.67em",
    marginBottom: "0.33em",
  },

  notificationBlockButtonsItem: {
    paddingLeft: "1.67em",
    paddingRight: "1.67em",
    paddingTop: "0.23em",
    paddingBottom: "0.23em",
    fontSize: "1em",
    borderRadius: "0.40em",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      paddingLeft: "2.1em",
      paddingRight: "2.1em",
    },
  },
  notificationBlockButtonsItemQuota100: {
    paddingLeft: "1.5em",
    paddingRight: "1.5em",
    paddingTop: "0.16em",
    paddingBottom: "0.16em",
  },
}));
